import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { useStateInRef } from '../../utils/useStateInRef';
import { BiContext, keysToSnakeCase } from './BiContext';
export function BiProvider(param) {
    let { children, logBi } = param;
    const getLogBi = useStateInRef(logBi);
    const logBiAction = useCallback((biEvent)=>{
        var _biEvent_hierarchy;
        getLogBi()(_object_spread_props(_object_spread({}, keysToSnakeCase(biEvent.data)), {
            type: 'click',
            action_type: biEvent.actionType,
            entity_type: biEvent.entityType,
            entity_name: biEvent.entityName,
            hierarchy: (_biEvent_hierarchy = biEvent.hierarchy) !== null && _biEvent_hierarchy !== void 0 ? _biEvent_hierarchy : []
        }));
    }, []);
    const logBiPageView = useCallback((biEvent)=>{
        getLogBi()(_object_spread_props(_object_spread({}, keysToSnakeCase(biEvent.data)), {
            type: 'page_view',
            page_name: biEvent.pageName,
            hierarchy: [
                biEvent.pageName
            ]
        }));
    }, []);
    const logBiModalView = useCallback((biEvent)=>{
        var _biEvent_hierarchy;
        getLogBi()(_object_spread_props(_object_spread({}, keysToSnakeCase(biEvent.data)), {
            type: 'modal_view',
            entity_type: 'modal',
            entity_name: biEvent.modalName,
            hierarchy: (_biEvent_hierarchy = biEvent.hierarchy) !== null && _biEvent_hierarchy !== void 0 ? _biEvent_hierarchy : [],
            modal_state: biEvent.modal_state
        }));
    }, []);
    const startTransaction = useCallback((input)=>{
        var _input_hierarchy;
        const startTime = performance.now();
        getLogBi()(_object_spread_props(_object_spread({}, keysToSnakeCase(input.data)), {
            type: 'transaction',
            transaction_name: input.transactionName,
            status: 'start',
            hierarchy: (_input_hierarchy = input.hierarchy) !== null && _input_hierarchy !== void 0 ? _input_hierarchy : []
        }));
        return (endData)=>{
            var _input_hierarchy;
            const durationMs = Math.round(performance.now() - startTime);
            getLogBi()(_object_spread_props(_object_spread({}, keysToSnakeCase(input.data), keysToSnakeCase(endData)), {
                type: 'transaction',
                transaction_name: input.transactionName,
                status: 'end',
                duration_ms: durationMs,
                hierarchy: (_input_hierarchy = input.hierarchy) !== null && _input_hierarchy !== void 0 ? _input_hierarchy : []
            }));
        };
    }, []);
    const value = useMemo(()=>({
            logBiAction,
            logBiPageView,
            logBiModalView,
            startTransaction
        }), [
        logBiAction,
        logBiPageView,
        logBiModalView,
        startTransaction
    ]);
    const getValue = useStateInRef(value);
    return /*#__PURE__*/ _jsx(BiContext.Provider, {
        value: getValue,
        children: children
    });
}
